import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { WarningIcon } from '../../../custom_shared/icons';
import './ErrorsRenderer.less';

interface Props {
    errors: string[];
}

const ErrorsRenderer: React.FC<Props> = ({ errors }) => {
    if (!errors.length) {
        return null;
    }

    return (
        <div className="errors-renderer-container">
            <div className="errors-renderer-content">
                <div className="errors-renderer-left-column">
                    <WarningIcon />
                </div>

                <div className="errors-renderer-right-column">
                    {errors.map((error, index) => (
                        <span key={`${error}-${index}`} className="errors-renderer-label">
                            {error}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default observer(ErrorsRenderer);
